import React from 'react';

import { ConfirmDialog, Stack, Typography, Grid } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import FinancialResultTitle from 'scenes/FinancialResults/components/FinancialResultTitle';
import { loadUsersSuggestions } from 'scenes/FinancialResults/sources/financialResults';

import { COMMENT } from './constants';
import { commentConfirmDialogSchema } from './schema';
import AlertOnDraft from 'scenes/FinancialResults/components/Draft/AlertOnDraft';

export const CommentConfirmDialog = withForm({
  validationSchema: commentConfirmDialogSchema,
  enableReinitialize: true,
})(({
  values,
  open,
  fr,
  title = 'Add comment',
  confirmActionLabel = 'Save',
  commentRequired = false,
  submitForm,
  onExited,
  onClose,
  showDraftAlert = false,
}) => {
  const handleSubmit = () => {
    submitForm(values);
  };
  const handleValidate = (value) => {
    if (commentRequired && (!value || value?.length === 0)) {
      return 'Comment is required';
    }
    return false;
  };

  return (
    <ConfirmDialog
      title={title}
      open={open}
      confirmActionLabel={confirmActionLabel}
      onExited={onExited}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <Stack spacing={2}>
        {showDraftAlert && (
          <Grid item sx={12}>
            <AlertOnDraft />
          </Grid>
        )}

        <Typography>
          <FinancialResultTitle {...fr} />
        </Typography>
        <Grid item xs={12}>
          <FormField.MentionsRichText
            validate={handleValidate}
            label={`Comment${commentRequired ? '*' : ' (optional)'}`}
            padding={0}
            name={COMMENT}
            autofocus={true}
            loadMentions={loadUsersSuggestions}
          />
        </Grid>
      </Stack>
    </ConfirmDialog>
  );
});
